import type { MessageDescriptor } from 'react-intl';

import messages from '@atlassian/conversation-assistant/messages/edit-with-rovo-bar';

export type VariantOption = {
	value: string;
	label: MessageDescriptor;
	updateChatMessage: MessageDescriptor;
	/**
	 * Override the parent remix type when emitting this variant to the backend.
	 *
	 * The variant still appears in its parent group in the UI, but when
	 * selected the backend receives this type instead of the parent key.
	 */
	emitType?: string;
};

export const defaultInfographicVariants: VariantOption[] = [
	{
		value: 'corporate-modern',
		label: messages.remixVariantModernStyle,
		updateChatMessage: messages.chatUpdateModernStyle,
	},
	{
		value: 'corporate-doodle',
		label: messages.remixVariantSketchStyle,
		updateChatMessage: messages.chatUpdateSketchStyle,
	},
];

export const newInfographicVariants: VariantOption[] = [
	{
		value: 'charlie',
		label: messages.remixVariantBoldStyle,
		updateChatMessage: messages.chatUpdateBoldStyle,
	},
	{
		value: 'minimalist',
		label: messages.remixVariantMinimalistStyle,
		updateChatMessage: messages.chatUpdateMinimalistStyle,
	},
	{
		value: 'corporate-doodle',
		label: messages.remixVariantSketchStyle,
		updateChatMessage: messages.chatUpdateSketchStyle,
	},
];

export function getInfographicVariants({
	useNewStyles,
}: {
	useNewStyles: boolean;
}): VariantOption[] {
	return useNewStyles ? newInfographicVariants : defaultInfographicVariants;
}

export const defaultVisualAidVariants: VariantOption[] = [
	{
		value: 'flip-cards',
		label: messages.remixVariantFlipCard,
		updateChatMessage: messages.chatUpdateFlipCard,
	},
	{
		value: 'quadrant',
		label: messages.remixVariantQuadrant,
		updateChatMessage: messages.chatUpdateQuadrant,
	},
	{
		value: 'tree-map',
		label: messages.remixVariantTreeMap,
		updateChatMessage: messages.chatUpdateTreeMap,
	},
	{
		value: 'horizontal-timeline',
		label: messages.remixVariantTimeline,
		updateChatMessage: messages.chatUpdateTimeline,
	},
	{
		value: 'map',
		label: messages.remixVariantGeographicalMap,
		updateChatMessage: messages.chatUpdateGeographicalMap,
	},
	{
		value: 'org-chart',
		label: messages.remixVariantOrgChart,
		updateChatMessage: messages.chatUpdateOrgChart,
	},
	{
		value: 'gantt-chart',
		label: messages.remixVariantGanttChart,
		updateChatMessage: messages.chatUpdateGanttChart,
	},
];

const imageVariant: VariantOption = {
	value: 'image',
	label: messages.remixVariantImage,
	updateChatMessage: messages.chatUpdateImage,
	emitType: 'infographic',
};

export function getVisualAidVariants({ enableImage }: { enableImage: boolean }): VariantOption[] {
	return enableImage ? [...defaultVisualAidVariants, imageVariant] : defaultVisualAidVariants;
}
